import React, { PureComponent } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, Modal } from 'semantic-ui-react'
import { Checkbox } from 'semantic-ui-react'
import ElementLoader from './element_loader'

export default class PermissionsTable extends PureComponent {

  constructor(props){
    super(props)
    this.state = this.getPermissionState()
    this.state.loading = props.formMode === 'edit_plan_permissions' ? true : false
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.permissionsTableState !== this.props.permissionsTableState){
      const newState = this.getPermissionState()
      newState.loading = false
      this.setState(newState);
    }
  }

  getPermissionState = () => {
    return {
      selectAllEdit: this.props.permissionsTableState.selectAllEdit,
      selectAllView: this.props.permissionsTableState.selectAllView,
      planPermissions: [...this.props.permissionsTableState.planPermissions]
    }
  }

  save = () => {
    this.props.close(this.state)
  }

  close = () => {
    this.props.close()
  }

  renderCheckboxCell = (cell, row, rowIndex, formatExtraData) => {
    const attribute = formatExtraData.attribName
    let checkAll = this.state.selectAllPermission

    return <Checkbox
      className=""
      style={{margin: 0, marginLeft: '6px'}}
      onClick={ e => {
        const plans = [...this.state.planPermissions]
        const plan = {...plans[rowIndex]}
        plans[rowIndex] = plan
        let selectAllEdit = this.state.selectAllEdit
        let selectAllView = this.state.selectAllView
        plan[attribute] = !cell

        if( attribute === "can_update" && plan.can_update ){
          plan.can_read = true
          checkAll = !plans.some( plan => !plan.can_update )
          if(checkAll){
            selectAllEdit = true
            selectAllView = true
          }
        } else {
          selectAllView = !plans.some( plan => !plan.can_read )
          if(!plan.can_read){ plan.can_update = false }
          if(!plan.can_update){ selectAllEdit = false }
        }

        this.setState({
          planPermissions: plans,
          selectAllEdit: selectAllEdit,
          selectAllView: selectAllView,
        })
      }}
      checked={cell} />
  }

  renderCheckboxHeader = (column, colIndex, components) => {
    const attribute = column.dataField

    return <div>
      <Checkbox
        className=""
        style={{margin: '0px 8px -6px 6px'}}
        onClick={ e => {
          const newState = {}
          const isChecked = !this.state[column.stateAttribute]
          let plans = [...this.state.planPermissions]

          if( attribute === 'can_update' ){
            newState.selectAllEdit = isChecked
            if(isChecked){
              newState.selectAllView = isChecked
              plans = plans.map( plan => {
                const newPlan = {...plan}
                newPlan.can_update = true
                newPlan.can_read = true
                return newPlan
              })
            } else {
              plans = plans.map( plan => {
                const newPlan = {...plan}
                newPlan.can_update = false
                return newPlan
              })
            }

          } else {
            if( isChecked ){
              newState.selectAllView = isChecked
              plans = plans.map( plan => {
                const newPlan = {...plan}
                newPlan.can_read = isChecked
                return newPlan
              })
            } else {
              newState.selectAllEdit = false
              newState.selectAllView = false
              plans = plans.map( plan => {
                const newPlan = {...plan}
                newPlan.can_update = false
                newPlan.can_read = false
                return newPlan
              })
            }
          }

          newState.planPermissions = plans
          this.setState(newState)
        }}
        checked={this.state[column.stateAttribute]} />
        &nbsp;{column.text}
      </div>
  }

  getUserName = () => {
    if(!this.props.user.profile.first_name && !this.props.user.profile.last){
      return ""
    }
    return `${this.props.user.profile.first_name} ${this.props.user.profile.last_name}`.trim() + " - "
  }

  render(){
    const { open, translations } = this.props

    return <Modal className='user-form-modal' size="small" open={ open }>
      <Modal.Header>
        { this.getUserName() } Plan Permissions
      </Modal.Header>
      <Modal.Content className="scrolling scrolling-table padding-0 position-relative">
        <ElementLoader isLoading={this.state.loading} />
        <BootstrapTable
          keyField="plan_id"
          rowStyle={{ borderColor: 'transparent !imporant'}}
          bordered={false}
          striped
          condensed
          style={{ borderColor: 'transparent !important' }}
          data={this.state.planPermissions}
          noDataIndication={() => <span className="no-data-indication"><i className="file alternate icon"></i>No plans available</span>}
          columns={[
            { dataField: 'plan_name',
              text: translations.name,
              formatter: cell => <div className="cell-style">
                <span>{cell}</span>
              </div>,
              headerTitle: true,
              headerFormatter: column => <div>{translations.name}</div>,
              headerStyle: { width: '70%' },
              editable: false,
            },{
              dataField: 'can_read',
              text: "View",
              formatter: this.renderCheckboxCell,
              headerFormatter: this.renderCheckboxHeader,
              headerTitle: true,
              headerStyle: { width: '15%' },
              editable: false,
              stateAttribute: 'selectAllView',
              formatExtraData: { attribName: 'can_read' }
            },{
              dataField: 'can_update',
              text: "Edit",
              formatter: this.renderCheckboxCell,
              headerFormatter: this.renderCheckboxHeader,
              headerTitle: true,
              headerStyle: { width: '15%' },
              editable: false,
              stateAttribute: 'selectAllEdit',
              formatExtraData: { attribName: 'can_update' }
            }
          ]} />
      </Modal.Content>
      <Modal.Actions>
        {this.state.planPermissions.every(plan => !plan.can_read && !plan.can_update) && (
          <p className='user-plan-permissions-error-message'>{"Must have at least 1 permission"}</p>
        )}
        <Button
          color='teal'
          fluid
          size='medium'
          className="new-plan-button"
          onClick={this.save}
          disabled={this.state.planPermissions.every(plan => !plan.can_read && !plan.can_update)}
        >
          {translations.save}
        </Button>
      </Modal.Actions>
      <i className="delete icon" onClick={this.close}></i>
    </Modal>
  }
}



// WEBPACK FOOTER //
// ./src/components/permissions_table.js